import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
import moment from 'moment'
import Enum from '@/shared/enum'
import ErrorMessage from '../../components/ErrorMessage.vue'
import permission from '../permission'
import CreateButton from '../components/CreateButton'
import FilterMixin from './FilterMixin'
import 'bootstrap-datepicker'

var SearchMixin = {
  mixins: [FilterMixin],
  data() {
    return {
      name: this.$options.name.toLowerCase(),
      entites: [],
      CRUDMODE: Enum.Mode,
      serviceClient: {},
      error: '',
      canCreate: true,
      canDelete: true,
      datatableFilter: [],
      datatableOptions: {},
    }
  },
  created: function() {
    this.fetchData()
    this.getPermissions()

    this.dataTableFilter = []
    $.fn.dataTable.ext.search = []
  },
  methods: {
    getPermissions: function() {
      let perm = this.$route.meta.permission
      if (perm != null) {
        let createList = _.cloneDeep(perm)
        let deleteList = _.cloneDeep(perm)

        createList.forEach((o, i, a) => (a[i] = a[i].replace('View', 'Create')))
        deleteList.forEach((o, i, a) => (a[i] = a[i].replace('View', 'Delete')))

        this.canCreate = permission.checkPermission(createList)
        this.canDelete = permission.checkPermission(deleteList)
      }
    },
    fetchData: function() {
      let service = ServiceFactory.create(this.serviceClient)
      let self = this
      service
        .getAll('', 0, 10000)
        .then(res => {
          self.entites = res.items
          self.showDataTable(self.datatableOptions, self)
        })
        .catch(err => {
          this.getErrorMessage(err)
        })
    },
    showDataTable: function(props, self) {
      if (self == null) self = this

      if ($.fn.DataTable.isDataTable('#dataTable')) {
        $('#dataTable')
          .DataTable()
          .destroy()
      }

      $('#dataTable tfoot th:not(".drop-down-filter, .no-filter, .date-range-filter")').each(function() {
        var title = $(this).text()
        $(this).html('<input type="text" placeholder="' + title + '" class="form-control" />')
      })

      setTimeout(function() {
        $.fn.dataTable.moment('YYYY-MM-DD')

        $('#dataTable').dataTable(
          _.merge(
            {},
            {
              dom: '<"row"<"col-md-6"BlT><"col-md-6"fg>>t<"row"<"col-md-6"i><"col-md-6"p>>',
              retrieve: true,
              bJQueryUI: true,
              bSort: true,
              bPaginate: true,
              sPaginationType: 'full_numbers',
              iDisplayLength: 15,
              fnDrawCallback: function(oSettings) {
                let dataTable = $('#dataTable')
                dataTable.show()
              },
              initComplete: function() {
                let dataTable = $('#dataTable')
                var table = dataTable.DataTable()

                table.columns().every(function() {
                  var that = this
                  $('input', that.footer()).on('keyup change', function() {
                    if (that.search() !== this.value) that.search(this.value.replace(/;/g, '|'), true, false).draw()
                  })
                })

                table.columns('.date-range-filter').every(function(columnId) {
                  var that = this

                  var dateFrom = $('<input type="text" class="from datepicker form-control" />').on('change', function() {
                    self.applyDateFilter(that, table)
                  })

                  var dateTo = $('<input type="text" class="to datepicker form-control" />').on('change', function() {
                    self.applyDateFilter(that, table)
                  })

                  var text = $('<span>&nbsp;to&nbsp;</span>')

                  var div = $("<div class='input-group' id='date-filter-" + that.selector.cols + "'>")
                    .append(dateFrom)
                    .append(text)
                    .append(dateTo)

                  $(this.footer())
                    .empty()
                    .append(div)
                })

                table.columns('.drop-down-filter').every(function() {
                  var that = this

                  var select = $('<select class="form-control select2" multiple="multiple" />').on('change', function() {
                    let values = $(this)
                      .val()
                      .join('|')

                    this.datatableFilter = _.filter(this.datatableFilter, x => {
                      return x.id != that.selector.cols
                    })

                    if (values.trim() != '') {
                      that.search('(' + values + ')', true, false)
                    } else if (/^\s+$/.test(values)) {
                      this.datatableFilter.push({
                        id: that.selector.cols,
                        func: function(settings, data, dataIndex) {
                          return data[that.selector.cols].trim() == ''
                        },
                      })
                    } else {
                      that.search('')
                    }
                    $.fn.dataTable.ext.search = _.map(this.datatableFilter, 'func')
                    table.draw()
                  })

                  $(this.footer())
                    .empty()
                    .append(select)

                  var values = []

                  _.uniq([].concat.apply([], this.cache('search').map(x => x.split(', '))))
                    .sort()
                    .forEach(function(d) {
                      var array = d.split(',')
                      if (Array.isArray(array)) {
                        array.forEach(function(value) {
                          if (!values.includes(value)) {
                            values.push(value)
                          }
                        })
                      }

                      // select.append($('<option value="' + d + '">' + d + '</option>'))
                    })

                  values.forEach(function(value) {
                    select.append($('<option value="' + value + '">' + value + '</option>'))
                  })
                })

                self.applyJqueryComponents()

                $('tfoot tr', dataTable).appendTo('thead', dataTable)
              },
              buttons: [
                {
                  extend: 'excel',
                  title: this.name,
                  text: 'Export Excel',
                  exportOptions: {
                    columns: [':not(.not-export)'],
                  },
                },
                {
                  extend: 'pdf',
                  title: this.name,
                  text: 'Export PDF',
                  exportOptions: {
                    columns: ':visible',
                  },
                  orientation: 'landscape',
                  pageSize: 'LEGAL',
                }, //'copy', 'csv','pdf' , 'print'
              ],
              columnDefs: [{targets: 'export', visible: false}],
            },
            props
          )
        )
      }, 500)
    },
    applyJqueryComponents: function() {
      $('.select2').select2({
        language: 'fr',
      })

      $('.datepicker').datepicker({
        format: 'dd/mm/yyyy',
        autoclose: true,
        clearBtn: true,
      })
    },
    applyDateFilter: function(cell, table) {
      let valueTo = $('#date-filter-' + cell.selector.cols + ' .to').val()
      let valueFrom = $('#date-filter-' + cell.selector.cols + ' .from').val()

      this.datatableFilter = _.filter(this.datatableFilter, x => {
        return x.id != cell.selector.cols
      })

      if (valueTo != '' || valueFrom != '') {
        this.datatableFilter.push({
          id: cell.selector.cols,
          func: function(settings, data, dataIndex) {
            let column = moment(data[cell.selector.cols], 'DD-MM-YYYY')

            return (
              (moment(valueFrom, 'DD-MM-YYYY').isBefore(column) || valueFrom == '') &&
              (valueTo == '' || moment(valueTo, 'DD-MM-YYYY').isAfter(column))
            )
          },
        })
      }

      $.fn.dataTable.ext.search = _.map(this.datatableFilter, 'func')
      table.draw()
    },
    deleteEntity: function(id) {
      let service = ServiceFactory.create(this.serviceClient)
      this.processDelete(this, service, id, this.name)
    },
    processDelete: function(self, service, id, elementText) {
      swal({
        title: 'Êtes-vous sûr?',
        text: 'Cette action supprimera définitivement le ' + elementText + ' !',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(willDelete => {
        if (willDelete) {
          service.delete(id).then(res => {
            $('#dataTable')
              .dataTable()
              .fnDeleteRow(self.$el.querySelector("#dataTable tr[data-id='" + id + "']"))

            swal(elementText + ' supprimé avec succès!', {
              icon: 'success',
            })
          })
        } else {
          this.getErrorMessage(res)
        }
      })
    },
    create: function() {
      this.$router.push({name: this.name + '_create'})
    },
    edit: function(id) {
      this.$router.push({name: this.name + '_edit', params: {id: id}})
    },
    view: function(id) {
      this.$router.push({name: this.name + '_view', params: {id: id}})
    },
    copy: function(id) {
      this.$router.push({name: this.name + '_copy', params: {id: id}})
    },
    getErrorMessage: function(err) {
      return err.message + ' - ' + JSON.parse(err.response).message
    },
  },
  components: {
    errorMessage: ErrorMessage,
    createButton: CreateButton,
  },
}
export default SearchMixin



// WEBPACK FOOTER //
// ./src/shared/Mixin/SearchMixin.js